/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Title_DataInputs */

const fr_page_title_data = /** @type {(inputs: Page_Title_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données des réseaux - Bus-Tracker`)
};

const en_page_title_data = /** @type {(inputs: Page_Title_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Network data - Bus-Tracker`)
};

/**
* | output |
* | --- |
* | "Network data - Bus-Tracker" |
*
* @param {Page_Title_DataInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_title_data = /** @type {((inputs?: Page_Title_DataInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Title_DataInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_page_title_data(inputs)
	return en_page_title_data(inputs)
});